import { Box } from '@apia/theme';
import { FunctionComponent } from 'react';
import {
  TResponsiveTableCell,
  TResponsiveTableColumn,
  TResponsiveTableRow,
} from '../types';

export type TAccordionCellRendererProps<CellProps = Record<string, unknown>> = {
  cell: TResponsiveTableCell<CellProps>;
  column: TResponsiveTableColumn;
  columnIndex: number;
  row: TResponsiveTableRow;
  rowIndex: number;
};

export type TAccordionCellRenderer<CellProps = Record<string, unknown>> =
  FunctionComponent<TAccordionCellRendererProps<CellProps>>;

const NoMemoAccordionCell: TAccordionCellRenderer = ({ cell, column }) => {
  return (
    <Box
      key={column.name}
      className={`responsiveTable__accordionElement__column ${
        cell.className ?? ''
      }`}
    >
      <Box as="strong">{column.label ?? column.name}: </Box>
      <Box as="span" sx={{ color: cell.color, background: cell.background }}>
        {cell?.children}
      </Box>
    </Box>
  );
};

export const AccordionCell = NoMemoAccordionCell;
